<template>
  <div>
    <div class="ti-but layout-row" @click="showTap()">
      <div v-if="!show" class="ti_show_but layout-row">
        <div>查看原题</div>
        <img src="../../image/gray_down_icon.png" alt="" />
      </div>
      <div v-else class="ti_show_but layout-row">
        <div>收起</div>
        <img
          style="transform: rotateX(180deg)"
          src="../../image/gray_down_icon.png"
          alt=""
        />
      </div>
    </div>
    <div class="show-body" v-if="show && ti_item" @click="oneTi()">
      <div class="body" v-if="ti_item.type < 3">
        <div class="topic-title font-16-333">
          {{ ti_item.s_num }}.{{ ti_item.title }}
        </div>
        <div class="option-body">
          <div
            v-for="e of ti_item.option"
            :key="e.key"
            class="option-item layout-row"
            :class="{
              type1: e.user_status == 1,
              type2: e.user_status == 2,
            }"
          >
            <div
              class="ico"
              :class="{
                ico1: e.user_status == 1,
                ico2: e.user_status == 2,
              }"
            ></div>
            <div>{{ e.key }}. {{ e.value }}</div>
          </div>
        </div>
      </div>

      <div class="body" v-if="ti_item.type == 4">
        <div class="topic-title font-16-333" v-html="ti_item.show_title"></div>
      </div>

      <div class="body" v-if="ti_item.type > 4">
        <div class="topic-title font-16-333">
          {{ ti_item.s_num }}.{{ ti_item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      show: false,
      type: 2,
      load: false,
      ti_item: false,
    };
  },
  created() {},
  methods: {
    showTap() {
      this.show = !this.show;
      this.get_question();
    },

    oneTi() {
      if (!this.oneObj) {
        return;
      }
      this.$store.commit("topic/setOneTi", this.oneObj);
      sessionStorage.setItem("updatetiList", 1);
      let data = {
        mode: 0,
        index: 0,
        see: 1,
        title: this.oneObj.chapter_title,
        tab_key: this.item.tab_key || this.$route.query.tab_key,
        sheet_id: this.$route.query.sheet_id,
        sheet_type: this.$route.query.sheet_type,
        chapter_id: this.oneObj.chapter_id,
        question_id: this.oneObj.question_id,
        source: 1,
      };
      if (this.$route.query.sheet_type) {
        data.source = 2;
      }

      this.$router.push({
        path: "/h5/tiku/exam2",
        query: data,
      });
    },
    get_question() {
      if (this.load) {
        return;
      }

      this.load = true;
      let url = "/tiku/get_question";
      if (this.$route.query.sheet_type) {
        url = "/tiku/get_sheet_question_info";
      }
      this.$axios
        .get(url, {
          params: {
            question_id: this.item.question_id,
            sheet_id: this.$route.query.sheet_id,
            sheet_type: this.$route.query.sheet_type,
            // type: 4,
            tab_key: this.item.tab_key||this.$route.query.tab_key,
            is_loading: true,
          },
        })
        .then((res) => {
          let list = merge_materials_list(
            res.data.materials_list,
            res.data.list
          );
          let oneObj = list[0];

          this.oneObj = JSON.parse(JSON.stringify(oneObj));
          oneObj.user_answer = oneObj.answer;
          list.map((item) => {
            item.option = item.option.map((e) => {
              e.user_status = 1;
              e.status = 0;
              return e;
            });
            item.is_blanks = 0;
            if (item.type == 20) {
              item.type = 4;
            }
            this.answer_init(item);
            this.blanks(item);
            return item;
          });

          this.ti_item = list[0];
        });
    },
    blanks(item) {
      if (!item.blanks_answer) {
        return;
      }
      item.blanks_answer = item.blanks_answer.split("||");
      let i = 0;
      item.hidden_title = item.title.replace(/%s/gi, () => {
        return `<span style="border-bottom: 1px solid #030000;color:#fff;">${
          item.blanks_answer[i++]
        }</span>`;
      });
      item.hidden_title = `${item.s_num}.` + item.hidden_title;
      item.hidden_title = item.hidden_title.replace(/&&/gi, "<br/>");
      i = 0;
      item.show_title = item.title.replace(/%s/gi, () => {
        return `<span style="border-bottom: 1px solid #030000;color:#333;">${
          item.blanks_answer[i++]
        }</span>`;
      });
      item.show_title = `${item.s_num}.` + item.show_title;
      item.show_title = item.show_title.replace(/&&/gi, "<br/>");
    },
    answer_init(item) {
      let user_answer = item.answer.split(",");
      item.option = item.option.map((e) => {
        let b = false;
        for (let ee of user_answer) {
          if (ee == e.key) {
            b = true;
          }
        }
        e.user_status = b ? 2 : 1;
        e.status = 0;
        return e;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ti-but {
  padding-top: 0.5rem;
}
.ti_show_but {
  align-items: center;
  justify-content: center;
  //   width: 3.75rem;
  padding: 0 0.4rem;
  height: 0.95rem;
  border: 1px solid #eaeaea;
  border-radius: 0.5rem;
  font-size: 0.6rem;
  color: #999;
  img {
    margin-left: 0.25rem;
    width: 0.4rem;
    height: 0.2rem;
  }
}
>>> .topicHidden {
  border-bottom: 1px dashed #030000;
  color: #fff;
}
>>> .topicShow {
  border-bottom: 1px dashed #030000;
}
.show-body {
  background-color: #f0f0f0;
  padding: 0 0.5rem;
  border-radius: 0.25rem;
  margin-top: 0.5rem;
}
.body {
  padding: 0.65rem 0;
  .topic-title {
    line-height: 1.25rem;
  }

  .option-body {
    .type1 {
      color: #333;
    }
    .type2 {
      color: #333;
    }
    .option-item {
      padding: 0.25rem 0;
      font-size: 0.75rem;
      // align-items: center;
      .ico {
        margin-top: 0.1rem;
        width: 1rem;
        height: 1rem;
        flex-shrink: 0;
        border-radius: 50%;
        margin-right: 0.5rem;
        box-sizing: border-box;
        border: 1px solid #666666;
      }

      .ico1 {
        border: 1px solid #666666;
      }
      .ico2 {
        background-image: url(../../image/icon_options_select_yes.png);
        background-size: 1rem 1rem;
        border: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/primaryTi.vue